import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import { ERP_OPTIONS, OTHER_VALUE } from '@components/tenantStatus/onboardingWizard/constants';
import type { ErpStepProps } from '@components/tenantStatus/onboardingWizard/types';
import ChipGroup from '@components/tenantStatus/onboardingWizard/components/ChipGroup';
import WizardInput from '@components/tenantStatus/onboardingWizard/components/WizardInput';

const ErpStep = ({ C, data, onChange }: ErpStepProps) => {
  const otherSelected = data.selectedErp === OTHER_VALUE;

  return (
    <View>
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), marginBottom: scale(20) }]}>
        {i18n.t('ERP System')}
      </Text>

      <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>
        {i18n.t('Which ERP do you use?')}
      </Text>
      <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary'), marginBottom: scale(8) }]}>
        {i18n.t('Optional — select one')}
      </Text>
      <ChipGroup
        C={C}
        options={ERP_OPTIONS}
        selected={data.selectedErp ? [data.selectedErp] : []}
        multiSelect={false}
        onChange={(next) => onChange({ ...data, selectedErp: next[0] ?? null })}
        testIDPrefix="onboarding-wizard-erp-chip"
      />

      {otherSelected && (
        <View style={{ marginTop: scale(12) }}>
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), marginBottom: scale(8) }]}>
            {i18n.t('Which one?')}
          </Text>
          <WizardInput
            C={C}
            value={data.whichOneText}
            onChangeText={(whichOneText: string) => onChange({ ...data, whichOneText })}
            placeholder={i18n.t('Enter ERP system name...')}
            maxLength={70}
            testID="onboarding-wizard-erp-input"
          />
        </View>
      )}
    </View>
  );
};

export default ErpStep;
